module.exports = {
    apiKey :'AIzaSyA2zjNmUWOFkH-SFv7CsyEhGvEwV_Dzu7M'
}